<div class="card" [ngClass]="cardClass">
	<ng-container *ngIf="cardType === 'simple'">
		<ng-container *ngIf="headerTitle">
			<div class="card-header" [class.card-no-border]="!border" [class.pb-2]="padding" [ngClass]="header">
				<ng-container *ngIf="(dropdownType && options) || rightSideDetails">
					<div class="header-top">
						<ng-container *ngIf="headerTitle">
							<h5 [ngClass]="headerClass">
								{{ headerTitle }}
								<ng-content select="[header]"></ng-content>
							</h5>
						</ng-container>
						<ng-content select="[header2]"></ng-content>

						<div class="card-header-right-icon">
							<ng-content select="[header3]"></ng-content>
							<ng-container *ngIf="dropdownType && options">
								<app-card-dropdown-button
									[dropdownType]="dropdownType"
									[options]="options"
									[dropdownClass]="dropdownClass"
								>
								</app-card-dropdown-button>
							</ng-container>
						</div>
					</div>
					<ng-content select="[headerTitleValue]"></ng-content>
				</ng-container>

				<ng-container *ngIf="!((dropdownType && options) || rightSideDetails)">
					<h5 [ngClass]="headerClass">
						<ng-content select="[icon]"></ng-content>
						{{ headerTitle }}
						<ng-content select="[header4]"></ng-content>
					</h5>
					<ng-content select="[header5]"></ng-content>
				</ng-container>
			</div>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="cardType === 'classic'">
		<div class="card-header card-no-border">
			<ng-container *ngIf="headerTitle">
				<div class="common-space">
					<div class="left-header-content">
						<h5>{{ headerTitle }}</h5>

						<ng-container *ngIf="sortDescription">
							<p class="m-0 c-o-light">{{ sortDescription }}</p>
						</ng-container>
					</div>

					<ng-container *ngIf="buttonText">
						<div class="card-header-right-btn">
							<a class="c-o-light" href="javascript:void(0)" [routerLink]="path">{{ buttonText }}</a>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="cardType === 'dataTable'">
		<ng-container *ngIf="headerTitle">
			<div class="card-header" [class.card-no-border]="!border" [class.pb-2]="padding">
				<div class="header-top">
					<h5 [ngClass]="headerClass">
						{{ headerTitle }}
						<ng-content select="[header6]"></ng-content>
					</h5>
					<ng-content select="[header7]"></ng-content>
				</div>
			</div>
		</ng-container>
	</ng-container>

	<div class="card-body" [ngClass]="cardBodyClass">
		<ng-content></ng-content>
	</div>

	<ng-content select="[details]"></ng-content>
</div>
